import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private http: HttpClient) {}
  url: string = `${environment.apiUrl}v1/Auth`;

  getUsers() {
    return this.http.get(`${this.url}/Users`);
  }

  updateUser(username: string, data: any) {
    return this.http.put(`${this.url}/update/${username}`, data);
  }

  resetPassword(userName: string, newPassword: string) {
    return this.http.put(`${this.url}/reset-password/${userName}`, {
      newPassword: newPassword,
    });
  }

  deactivateUser(userName: string) {
    return this.http.put(`${this.url}/deactivate/${userName}`, {});
  }

  reactivateUser(userName: string) {
    return this.http.put(`${this.url}/reactivate/${userName}`, {});
  }

  addNewUser(userInfo: any) {
    return this.http.post(`${this.url}/Register`, userInfo);
  }

  getUserById(userName: string) {
    return this.http.get(`${this.url}/${userName}`);
  }

  login(username: string, password: string) {
    const body = { username, password };
    return this.http.post(`${this.url}/Login`, body, { responseType: 'text' });
  }

  saveToken(token: string) {
    document.cookie = `authToken=${token}; path=/; max-age=21600; SameSite=Lax`;
  }

  getToken(): string | null {
    const name = 'authToken=';
    const cookies = document.cookie.split(';');

    for (let cookie of cookies) {
      cookie = cookie.trim();
      if (cookie.startsWith(name)) {
        const token = cookie.substring(name.length);
        return token;
      }
    }
    return null;
  }

  removeToken() {
    document.cookie = 'authToken=; Max-Age=0; path=/';
  }

  deleteUser(userName: string) {
    return this.http.delete(`${this.url}/DeleteUser/${userName}`);
  }

  private decodeTokenPayload(): any | null {
    const token = this.getToken();
    if (!token) return null;

    try {
      const payloadBase64 = token.split('.')[1];
      const payloadDecoded = atob(payloadBase64);
      const payloadObject = JSON.parse(payloadDecoded);
      return payloadObject;
    } catch (error) {
      console.error('Invalid token format or decoding error:', error);
      return null;
    }
  }

  getStoreId(): number | null {
    const payloadObject = this.decodeTokenPayload();
    return payloadObject?.StoreId || null;
  }

  getCurrentUsername(): string | null {
    const payloadObject = this.decodeTokenPayload();
    return payloadObject?.username || payloadObject?.sub || null;
  }

  checkRole(): string | null {
    const payloadObject = this.decodeTokenPayload();
    return payloadObject?.role || null;
  }

  hasRole(expectedRole: string): boolean {
    const role = this.checkRole();
    return role === expectedRole;
  }

  getCurrentUser(): any | null {
    const payload = this.decodeTokenPayload();
    if (!payload) return null;
    return {
      username: payload?.username || payload?.sub || null,
      role: payload?.role || null,
      storeName: payload?.StoreName || null,
      storeId: payload?.StoreId || null,
    };
  }
}
